import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { ScrollSaver } from 'components';
import { useSongsStore, useUrlTagsParameters } from 'services/hooks';
import { FiltersBarContainer, SideBarContainer } from './components';
import useStyles from './style';
import { MobileFiltersDrawerContainer } from './components/mobile/MobileFiltersDrawer';
import MobileFiltersBarContainer from './components/mobile/MobileFiltersBar';

type PropsType = {
  children: React.ReactElement;
};

const FiltersLayout = (props: PropsType) => {
  const { children } = props;
  const classes = useStyles();

  useUrlTagsParameters();
  const { songsStore, saveScrollPosition } = useSongsStore();
  const { songListPosition } = songsStore;
  const thisRef = React.useRef(null);
  const scrollableRef = React.useRef(null);

  return (
    <div
      // @ts-ignore
      ref={thisRef}
      className={classes.root}
    >
      {isMobile ? <MobileFiltersDrawerContainer /> : <SideBarContainer />}
      <div ref={scrollableRef} className={classes.content}>
        {/* @ts-ignore */}
        <ScrollSaver
          scrollableParent={scrollableRef.current}
          saveScrollPosition={saveScrollPosition}
          savedScrollPosition={songListPosition}
        >
          {isMobile ? <MobileFiltersBarContainer /> : <FiltersBarContainer />}
          {children}
        </ScrollSaver>
      </div>
    </div>
  );
};

export default FiltersLayout;
